import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { memo, useMemo } from "react";

import type { ILabelProps } from "./types";
import classes from "./styles.module.scss";

import { Typography } from "@/components/atoms/typography";
import { Tooltip } from "@/components/molecules/tooltip";
import { Icon } from "@/components/atoms/icon";
import { usePageMode } from "@/stores/uiStore";

export const Label = memo(function Label(props: ILabelProps) {
  const {
    isRequired,
    labelSize = "medium",
    text,
    hintText,
    children,
    className,
    noTitle,
    forceMode,
    noRequiredOrOptional,
    ...rest
  } = props;

  const pageMode = usePageMode();
  const mode = forceMode || pageMode;
  const isDisplayBadge = useMemo(
    () => mode === "create" || mode === "index",
    [mode],
  );

  const { t } = useTranslation("component");

  return (
    <>
      {!noTitle && (
        <label className={clsx([className, classes.label])} {...rest}>
          <Typography
            fontType={
              labelSize === "medium" ? "label-small" : "paragraph-small"
            }
            themeColor={"text-strong-900"}
          >
            {text}
          </Typography>
          {isRequired && isDisplayBadge && !noRequiredOrOptional && (
            <Typography fontType={"label-small"} themeColor={"primary-base"}>
              {"*\r"}
            </Typography>
          )}
          {!isRequired && isDisplayBadge && !noRequiredOrOptional && (
            <Typography
              fontType={"paragraph-small"}
              themeColor={"text-sub-600"}
            >
              {`(${t("label.optional")})`}
            </Typography>
          )}
          {hintText && (
            <Tooltip title={hintText}>
              <div className={"icon-wrapper"}>
                <Icon
                  fontSize={"fs-16"}
                  color={"icon-disabled-300"}
                  name={"InformationFill"}
                />
              </div>
            </Tooltip>
          )}
        </label>
      )}
      {children}
    </>
  );
});
